var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view" },
    [
      _c(
        "v-card",
        { attrs: { width: "350" } },
        [
          _c(
            "div",
            {
              staticClass:
                "header navy darken-2 secondary--text pb-10 d-flex flex-column align-center",
            },
            [
              _c("img", {
                staticClass: "logo",
                attrs: { src: _vm.firebase_host + "/static/img/logo.png" },
              }),
            ]
          ),
          _vm._v(" "),
          _vm.astaInfo === false
            ? _c("v-progress-circular", {
                staticClass: "ma-10",
                attrs: { indeterminate: "" },
              })
            : _vm.astaInfo === null
            ? _c("NotFound", { attrs: { text: "Asta non trovata" } })
            : _c(
                "div",
                [
                  _vm.astaInfo.premium
                    ? _c(
                        "div",
                        { staticClass: "pa-4" },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "big-icon",
                              attrs: { color: "secondary" },
                            },
                            [_vm._v("check")]
                          ),
                          _vm._v(" "),
                          _c(
                            "h2",
                            { staticClass: "secondary--text font-hemi-head" },
                            [
                              _vm._v(
                                "\n          Asta sbloccata con successo\n        "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : !_vm.astaInfo.premium && _vm.paymentError
                    ? _c(
                        "div",
                        { staticClass: "pa-4" },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "big-icon",
                              attrs: { color: "error" },
                            },
                            [_vm._v("cancel")]
                          ),
                          _vm._v(" "),
                          _c(
                            "h2",
                            { staticClass: "error--text font-hemi-head" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.paymentError) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : !_vm.astaInfo.premium && _vm.paymentWarning
                    ? _c(
                        "div",
                        { staticClass: "pa-4" },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "big-icon",
                              attrs: { color: "warning" },
                            },
                            [_vm._v("warning")]
                          ),
                          _vm._v(" "),
                          _c(
                            "h2",
                            { staticClass: "warning--text font-hemi-head" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.paymentWarning) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass:
                            "px-8 py-5 d-flex flex-column align-center",
                        },
                        [
                          _c("h1", { staticClass: "font-hemi-head" }, [
                            _vm._v("Sblocca"),
                          ]),
                          _vm._v(" "),
                          _c("h2", { staticClass: "font-hemi-head" }, [
                            _c("b", [_vm._v(_vm._s(_vm.astaInfo.name))]),
                          ]),
                          _vm._v(" "),
                          _c("small", [
                            _vm._v("ASTA DA (MASSIMO)\n          "),
                            _c("b", [
                              _vm._v(_vm._s(_vm.astaInfo.lega.maxSquadre)),
                            ]),
                            _vm._v(" SQUADRE"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "prezzo-asta font-hemi-head" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.getPrezzoAsta(
                                      _vm.astaInfo.lega.maxSquadre
                                    )
                                  ) +
                                  " €\n        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "form",
                            {
                              attrs: {
                                action: _vm.endpoint,
                                method: "post",
                                target: "_top",
                              },
                            },
                            [
                              _c("input", {
                                attrs: {
                                  type: "hidden",
                                  name: "cmd",
                                  value: "_s-xclick",
                                },
                              }),
                              _vm._v(" "),
                              _c("input", {
                                attrs: {
                                  type: "hidden",
                                  name: "lc",
                                  value: "IT",
                                },
                              }),
                              _vm._v(" "),
                              _c("input", {
                                attrs: { type: "hidden", name: "custom" },
                                domProps: { value: _vm.customJson },
                              }),
                              _vm._v(" "),
                              _c("input", {
                                attrs: {
                                  type: "hidden",
                                  name: "hosted_button_id",
                                },
                                domProps: { value: _vm.buttonId },
                              }),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    large: "",
                                    depressed: "",
                                    type: "submit",
                                    value: "Paga con Payal",
                                    name: "submit",
                                    id: "paypal-btn",
                                    title:
                                      "PayPal è il metodo rapido e sicuro per pagare e farsi pagare online.",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.loader = true
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", color: "#003087" } },
                                    [_vm._v("fa-paypal")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "pay" }, [
                                    _vm._v("Pay"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "pal" }, [
                                    _vm._v("pal"),
                                  ]),
                                  _vm._v(" "),
                                  _vm.loader
                                    ? _c("v-progress-circular", {
                                        staticClass: "loader",
                                        attrs: {
                                          indeterminate: "",
                                          size: "16",
                                          color: "#ffc43a",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "cc d-flex justify-center mt-2",
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        _vm.firebase_host +
                                        "/static/img/cc-1.png",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    attrs: {
                                      src:
                                        _vm.firebase_host +
                                        "/static/img/cc-2.png",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    attrs: {
                                      src:
                                        _vm.firebase_host +
                                        "/static/img/cc-3.png",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    attrs: {
                                      src:
                                        _vm.firebase_host +
                                        "/static/img/cc-4.png",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("img", {
                                staticClass: "no-border",
                                attrs: {
                                  src: _vm.src,
                                  width: "1",
                                  height: "1",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mt-2",
                              staticStyle: { "text-transform": "none" },
                              attrs: { small: "", depressed: "", text: "" },
                              on: { click: _vm.openDialogCopyUrl },
                            },
                            [_vm._v("Non hai Paypal?")]
                          ),
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-space-between" },
                    [
                      _vm.Config.STANDALONE
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "ma-4",
                              staticStyle: { "text-transform": "none" },
                              attrs: { small: "", depressed: "", text: "" },
                              on: { click: _vm.gotoHome },
                            },
                            [_vm._v("Home")]
                          )
                        : _c("div"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-4",
                          staticStyle: { "text-transform": "none" },
                          attrs: { small: "", depressed: "", text: "" },
                          on: { click: _vm.gotoAsta },
                        },
                        [_vm._v("Vai all'Asta")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("dialog-copy-url-pagamento", {
                    attrs: { asta_id_: _vm.astaInfo.id },
                  }),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }